import * as auth from './auth'
import * as organization from './organization'
import * as storage from './storage'
import * as channel from './channel'
import * as group from './group'
import * as user from './user'
import * as modal from './modal'
import * as tag from './tag'
import * as upload from './upload'
import * as division from './division'

export default {
  auth,
  organization,
  user,
  storage,
  channel,
  group,
  modal,
  tag,
  upload,
  division
}



// WEBPACK FOOTER //
// ./src/store/actions/index.js